/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamCloseTimeSlotRequestInProgressOutcome } from './oralExamCloseTimeSlotRequestInProgressOutcome';

/**
 * Body for closing the time slot while students may still be mid-exam.
 */
export interface OralExamCloseTimeSlotRequest {
  inProgressOutcome?: OralExamCloseTimeSlotRequestInProgressOutcome;
}
